const cell = (v) => {
  const s = v === null || v === undefined ? "" : String(v);
  return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function downloadCsv(filename, header, rows) {
  const body = [header, ...rows].map((r) => r.map(cell).join(";")).join("\r\n");
  downloadBlob(new Blob(["\uFEFF" + body], { type: "text/csv;charset=utf-8" }), filename);
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
